import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import isNil from 'lodash/isNil'

import { observer } from 'mobx-react'

interface ItemProps {
  title: string
  value?: string
}

const DescriptionItem = ({ title, value }: ItemProps) => {
  if (isNil(value)) {
    return null
  }

  return (
    <Box flexDirection="row" gap="s4">
      <Text.Normal weight="semibold">{title}:</Text.Normal>
      <Text.Normal>{value}</Text.Normal>
    </Box>
  )
}

export default observer(DescriptionItem)
